export const getPresets = state => state.presets.presetsById;
export const getPresetsRequestStatus = state => state.presets.requestStatus;
export const getActiveThemePresetId = state => state.presets.activeThemePresetId;
export const getSelectedThemePresetId = state => state.presets.selectedThemePresetId;
export const getApplyPresetRequestStatus = state => state.presets.applyPresetRequestStatus;
export const getPresetsAsArray = state => Object.values(state.presets.presetsById);
export const getPresetById = (state, id) => state.presets.presetsById[id];
export const getActiveThemePresetStyles = state => {
  var _getPresetById;
  const activeThemePresetId = getActiveThemePresetId(state);
  return activeThemePresetId !== undefined ? (_getPresetById = getPresetById(state, activeThemePresetId)) === null || _getPresetById === void 0 ? void 0 : _getPresetById.styles : undefined;
};